/**
 * Explore product template interactions.
 * Runs only on .explore-product-page.
 * Assessment option cards map to real Shopify variant IDs.
 */
(function () {
  function formatMoney(cents, moneyFormat) {
    cents = parseInt(cents, 10) || 0;
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (Math.abs(cents) / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var withDecimals = parts.join(".");
    var noDecimals = String(Math.round(Math.abs(cents) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return String(moneyFormat || "AED {{amount}}")
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDecimals.replace(".", ","))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, withDecimals.replace(/,/g, "'"))
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals);
  }

  function normalize(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function optionKeyFromValue(value) {
    var n = normalize(value);
    if (!n || n === "default title" || n === "title") return "";
    if (n.indexOf("other") !== -1) return "other";
    if (n.indexOf("online") !== -1) return "online";
    if (n.indexOf("science park") !== -1 || n.indexOf("precision wellness") !== -1) return "clinic";
    if (n.indexOf("dubai") !== -1) return "dubai";
    if (n.indexOf("clinic") !== -1 || n.indexOf("homecare") === -1) {
      if (n.indexOf("clinic") !== -1) return "clinic";
    }
    return "";
  }

  function optionNameLooksLikeAssessment(name) {
    var n = normalize(name);
    return n.indexOf("assessment") !== -1 || n.indexOf("option") !== -1 || n.indexOf("location") !== -1;
  }

  function initExplorePage(root) {
    if (!root || root.getAttribute("data-explore-ready") === "1") return;
    root.setAttribute("data-explore-ready", "1");

    var main = document.getElementById("MainContent");
    if (main) {
      main.classList.remove("overflow-x-clip", "overflow-y-clip");
      main.classList.add("pwz-explore-main");
    }

    var cfgEl = root.querySelector("[data-explore-config]");
    var productEl = root.querySelector("[data-explore-product]");
    var variantInput = root.querySelector("#pwz-explore-variant-id");
    var config = {
      available: true,
      variantId: variantInput ? variantInput.value : "",
      moneyFormat: "AED {{amount}}",
      hasOnlyDefaultVariant: true,
      soldOutLabel: "Sold Out",
      addLabelPrefix: "ADD TO CART — ",
    };
    if (cfgEl) {
      try {
        config = Object.assign(config, JSON.parse(cfgEl.textContent));
      } catch (e) {}
    }

    var productData = { options: [], variants: [] };
    if (productEl) {
      try {
        productData = Object.assign(productData, JSON.parse(productEl.textContent));
      } catch (e) {}
    }

    var matchedVariant = null;
    var isAdding = false;

    function selectedOptionInput() {
      return root.querySelector('input[name="explore-option"]:checked') || root.querySelector('input[name="explore-option"]');
    }

    function selectedOptionKey() {
      var input = selectedOptionInput();
      return input ? input.value : "clinic";
    }

    function selectedOptionLabel() {
      var input = selectedOptionInput();
      if (!input) return "Precision Wellness, Dubai Science Park";
      var label = input.getAttribute("data-option-label");
      if (label) return label;
      var strong = input.closest(".location-option") && input.closest(".location-option").querySelector("strong");
      return strong ? strong.textContent.trim() : input.value;
    }

    function assessmentOptionIndex() {
      var options = productData.options || [];
      var index = -1;
      options.forEach(function (name, i) {
        if (index === -1 && optionNameLooksLikeAssessment(name)) index = i;
      });
      if (index === -1 && options.length) index = 0;
      return index;
    }

    function variantOptionValue(variant, index) {
      if (!variant || index < 0) return "";
      if (variant.options && variant.options[index] != null) return variant.options[index];
      if (index === 0) return variant.option1 || "";
      if (index === 1) return variant.option2 || "";
      if (index === 2) return variant.option3 || "";
      return "";
    }

    function variantKey(variant) {
      if (!variant) return "";
      var index = assessmentOptionIndex();
      return optionKeyFromValue(variantOptionValue(variant, index) || variant.title || variant.option1);
    }

    function findVariantForKey(wantKey) {
      var variants = productData.variants || [];
      if (!variants.length) return null;
      var matches = variants.filter(function (variant) {
        var key = variantKey(variant);
        if (!key && variants.length === 1) return true;
        return key === wantKey;
      });
      if (matches.length) {
        return matches.find(function (variant) { return variant.available; }) || matches[0];
      }
      if (variants.length === 1) return variants[0];
      return null;
    }

    function findMatchingVariant() {
      return findVariantForKey(selectedOptionKey()) || (productData.variants && productData.variants[0]) || null;
    }

    function applyMatchedVariant() {
      matchedVariant = findMatchingVariant();
      if (!matchedVariant) return;

      config.variantId = matchedVariant.id;
      config.available = matchedVariant.available !== false;
      config.price = Number(matchedVariant.price || 0);

      if (variantInput) {
        variantInput.value = matchedVariant.id;
        variantInput.setAttribute("data-price", String(config.price));
        variantInput.disabled = !config.available;
      }

      var optionProp = root.querySelector("#pwz-explore-option-prop");
      if (optionProp) optionProp.value = selectedOptionLabel();

      try {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", String(matchedVariant.id));
        window.history.replaceState({}, "", url.toString());
      } catch (e) {}
    }

    function markUnavailableOptions() {
      root.querySelectorAll('input[name="explore-option"]').forEach(function (input) {
        var variant = findVariantForKey(input.value);
        var option = input.closest(".location-option");
        if (!option) return;
        var unavailable = !!(variant && variant.available === false);
        option.classList.toggle("sold-out", unavailable);
        option.setAttribute("aria-disabled", unavailable ? "true" : "false");
        var badge = option.querySelector("[data-option-badge]");
        if (badge) {
          if (unavailable) {
            if (!badge.getAttribute("data-original-badge")) {
              badge.setAttribute("data-original-badge", badge.textContent.trim());
            }
            badge.textContent = config.soldOutLabel;
          } else if (badge.getAttribute("data-original-badge")) {
            badge.textContent = badge.getAttribute("data-original-badge");
          }
        }
      });
    }

    function updateTotal() {
      applyMatchedVariant();
      markUnavailableOptions();

      var total = matchedVariant
        ? Number(matchedVariant.price || 0)
        : Number((variantInput && variantInput.getAttribute("data-price")) || root.getAttribute("data-base-price") || 0);
      var money = formatMoney(total, config.moneyFormat);
      var available = !!(matchedVariant && matchedVariant.available);
      var mainPrice = root.querySelector("#pwz-explore-main-price");
      var totalEl = root.querySelector("#pwz-explore-total");
      var addMain = root.querySelector("#pwz-explore-add");
      var stickyPrice = root.querySelector("#pwz-explore-sticky-price");
      var stickyLabel = root.querySelector("#pwz-explore-sticky-label");
      var stickyAdd = root.querySelector("#pwz-explore-sticky-add");
      var buyNow = root.querySelector("#pwz-explore-buy");

      if (mainPrice) mainPrice.textContent = money;
      if (totalEl) totalEl.textContent = money;
      if (addMain) {
        addMain.disabled = !available;
        addMain.setAttribute("aria-disabled", available ? "false" : "true");
        addMain.textContent = available ? config.addLabelPrefix + money : config.soldOutLabel;
      }
      if (stickyPrice) stickyPrice.textContent = money;
      if (stickyLabel) stickyLabel.textContent = selectedOptionLabel();
      [stickyAdd, buyNow].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.setAttribute("aria-disabled", available ? "false" : "true");
        if (btn === stickyAdd) {
          btn.textContent = available ? "ADD TO CART" : config.soldOutLabel;
        }
      });

      root.querySelectorAll(".location-option").forEach(function (option) {
        var input = option.querySelector("input");
        option.classList.toggle("active", !!(input && input.checked));
      });
    }

    function showToast(message) {
      var toast = root.querySelector("#pwz-explore-toast");
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add("show");
      window.clearTimeout(showToast._timer);
      showToast._timer = window.setTimeout(function () {
        toast.classList.remove("show");
      }, 1500);
    }

    function dispatchCartUpdate(cart) {
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: "pwz-explore",
            data: {
              itemCount: cart && cart.item_count ? cart.item_count : 0,
              isIncremental: false,
              source: "pwz-explore",
            },
          },
        })
      );
      document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent("product-ajax:added", { bubbles: true, detail: { product: cart } }));
    }

    function collectItems() {
      applyMatchedVariant();
      var variantId = matchedVariant ? matchedVariant.id : variantInput ? variantInput.value : config.variantId;
      return [
        {
          id: Number(variantId),
          quantity: 1,
          properties: {
            "Assessment Option": selectedOptionLabel(),
          },
        },
      ];
    }

    function addToCart(options) {
      options = options || {};
      applyMatchedVariant();
      if (isAdding) return Promise.resolve();
      if (!matchedVariant || !matchedVariant.available) {
        showToast(config.soldOutLabel);
        return Promise.resolve();
      }
      isAdding = true;
      var buttons = root.querySelectorAll("#pwz-explore-add, #pwz-explore-sticky-add, #pwz-explore-buy");
      buttons.forEach(function (btn) {
        btn.setAttribute("aria-busy", "true");
      });
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: collectItems() }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            showToast(result.data.description || result.data.message || "Could not add to cart");
            return;
          }
          showToast(options.toast || "Explore added to cart");
          return fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              dispatchCartUpdate(cart);
              if (options.checkout) window.location.href = "/checkout";
            });
        })
        .catch(function () {
          showToast("Could not add to cart");
        })
        .finally(function () {
          isAdding = false;
          buttons.forEach(function (btn) {
            btn.removeAttribute("aria-busy");
          });
        });
    }

    root.querySelectorAll('input[name="explore-option"]').forEach(function (input) {
      input.addEventListener("change", updateTotal);
    });

    root.querySelectorAll(".thumb").forEach(function (btn) {
      btn.addEventListener("click", function () {
        root.querySelectorAll(".thumb").forEach(function (item) {
          item.classList.remove("active");
          item.setAttribute("aria-pressed", "false");
        });
        btn.classList.add("active");
        btn.setAttribute("aria-pressed", "true");
        root.querySelectorAll(".media-panel").forEach(function (panel) {
          panel.classList.remove("active");
          panel.setAttribute("hidden", "");
        });
        var panel = root.querySelector("#panel-" + btn.getAttribute("data-panel"));
        if (panel) {
          panel.classList.add("active");
          panel.removeAttribute("hidden");
        }
      });
    });

    var form = root.querySelector("#pwz-explore-form");
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        addToCart({ toast: "Explore added to cart" });
      });
    }

    var stickyAdd = root.querySelector("#pwz-explore-sticky-add");
    if (stickyAdd) {
      stickyAdd.addEventListener("click", function () {
        addToCart({ toast: "Explore added to cart" });
      });
    }

    var buyNow = root.querySelector("#pwz-explore-buy");
    if (buyNow) {
      buyNow.addEventListener("click", function () {
        addToCart({ toast: "Explore ready for checkout", checkout: true });
      });
    }

    var sticky = root.querySelector("#pwz-explore-sticky");
    if (sticky && root.getAttribute("data-sticky") !== "false") {
      var onScroll = function () {
        sticky.classList.toggle("show", window.scrollY > 850);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }

    var assessmentTrack = root.querySelector("#pwz-explore-assessment-track") || document.querySelector("#pwz-explore-assessment-track");
    var assessmentPrev = root.querySelector("#pwz-explore-assessment-prev") || document.querySelector("#pwz-explore-assessment-prev");
    var assessmentNext = root.querySelector("#pwz-explore-assessment-next") || document.querySelector("#pwz-explore-assessment-next");
    if (assessmentTrack && assessmentPrev && assessmentNext) {
      var move = function () {
        return Math.max(assessmentTrack.clientWidth * 0.72, 320);
      };
      assessmentPrev.addEventListener("click", function () {
        assessmentTrack.scrollBy({ left: -move(), behavior: "smooth" });
      });
      assessmentNext.addEventListener("click", function () {
        assessmentTrack.scrollBy({ left: move(), behavior: "smooth" });
      });
    }

    updateTotal();
  }

  function findAndInit(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll("[data-explore-config]").forEach(function (cfg) {
      var root = cfg.closest ? cfg.closest(".explore-product-page") : null;
      if (root) initExplorePage(root);
    });
  }

  findAndInit(document);

  document.addEventListener("shopify:section:load", function (event) {
    var target = event.target;
    if (!target) return;
    var cfg = target.querySelector ? target.querySelector("[data-explore-config]") : null;
    var root = cfg && cfg.closest ? cfg.closest(".explore-product-page") : document.querySelector("[data-explore-config]") && document.querySelector("[data-explore-config]").closest(".explore-product-page");
    if (root) {
      root.removeAttribute("data-explore-ready");
      initExplorePage(root);
    }
  });
})();
